// Mobile menu smooth scrool update
const closeCartDrawerOnJumpLinkClick = () => {
  const jumpLinks = document.querySelectorAll('.menu-drawer__menu-item[href^="#"]');

  jumpLinks.forEach((link) => {
    link.addEventListener('click', () => {
      const closeButton = /** @type {HTMLElement} */ (document.querySelector('.menu-drawer__close-button'));
      closeButton?.click();
    });
  });
};

document.addEventListener("DOMContentLoaded", closeCartDrawerOnJumpLinkClick);
document.addEventListener('shopify:section:load', closeCartDrawerOnJumpLinkClick);